import React ,{useState, useContext} from 'react'
import axios from "axios";
import {APIURL} from "../../Global";
import './hospprofile.css'
import {Button ,Modal } from 'react-bootstrap';

function PractiseUpdate(props) {

    const[practise ,setPractise] =useState('')
    const [show, setShow]= useState(false);
    const [submitMsg,setSubmitMsg] = useState("");
    const [errorMsg,setErrorMsg]=useState("");
    const [errorSubmit,setErrorSubmit]=useState(false);

    const [error,setError]=useState({
        practise:"",
       });

    const handleChange=(e)=>{
        e.preventDefault();
        const val=e.target.value;  
        const key=e.target.name;
      
          if(key==='practise'){
            setPractise(val)
          }  
        }

        const  validate = () => {
          //let input = email;
          let errors = {};
          let isValid = true;
    
          if (practise==="" ) {
            isValid = false;
            errors["practise"] = "Enter a practice type";
          }
      
          setError(currentstate=>({
            ...currentstate,...errors
          }))
      
          return isValid;
      }

      const handleContinue =async(e) => {
        e.preventDefault();
    
        if( validate() ){
          submitPractise()
        }
      }

        const submitPractise = (e) =>{
            const tokenString= sessionStorage.getItem('usertoken');
             
             let str= tokenString.replace(/["]+/g, '') 
          
             const data = {
              practise_type : practise
             }
          
             axios.put(`${APIURL}/api/v1/hospital/hospital-profile/` ,data, { headers: {
          
              "Authorization" : 'Token '+str  }})
            .then(res=>{
            
                  
              if(res.data.status==="success"){
                
                setSubmitMsg("success");
                setShow(true)             
            
              }else{
                setErrorMsg(res.data.message);
                setErrorSubmit(true);
              
               
              }
            
            })
            .catch(err=>{
              setErrorMsg("error");
  
              setErrorSubmit(true);
            
            })
          
          }


          const ConfirmPopUp = (props) => {
            return(
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                //  backdrop="static"
                  keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                   
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4 class="updated-message">Updated Successfully</h4>
                 
                </Modal.Body>
                <Modal.Footer>
                 
                   <Button variant="secondary" onClick={props.onHide}>Ok</Button>          
          
                </Modal.Footer>
              </Modal>
            )
          }
          
          
          const SubmitErrorPopup =(props)=>{
              
          
            return (
              <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                //  backdrop="static"
                  keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                   
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h5 class="updated-message" style={{color: "red"}}>Error in Data Submission. Please try again! </h5>
                 
                </Modal.Body>
                <Modal.Footer>
                 
                   <Button variant="secondary" onClick={props.onHide}>Ok</Button>
          
                 
                 
          
                </Modal.Footer>
              </Modal>
            );
          }



    return (
        <div>
            <div className="item">
              
            <div className="row">
                    <div className="radio-options">
                      <input
                        type="radio"
                        id="allopathy"
                        name="practise"
                        value="allopathy"
                        checked={practise === "allopathy"}
                        onChange={handleChange}
                      />
                      <label htmlFor="allopathy">
                        Allopathy/Modern Medicine
                      </label>
                    </div>

                    <div className="radio-options">
                      <input
                        type="radio"
                        id="ayurveda"
                        name="practise"
                        value="ayurveda"
                        checked={practise === "ayurveda"}
                        onChange={handleChange}
                      />
                      <label htmlFor="ayurveda">Ayurveda</label>
                    </div>

                    <div className="radio-options">
                      <input
                        type="radio"
                        id="homeopathy"
                        name="practise"
                        value="homeopathy"
                        checked={practise === "homeopathy"}
                        onChange={handleChange}
                      />
                      <label htmlFor="homeopathy">Homeopathy</label>
                    </div>

              </div>
              
              
              {/* <input className="form-control" type="text" maxLength="20" name="practise" placeholder="Practise Type" onChange={handleChange}/> */}

                {error.practise ? <div className="error-validation-msg"> {error.practise}</div> : null}

            </div>
            <br/>
            <div className="form-button">
                <button  onClick={handleContinue} className="btn btn-primary btn-col" >Update Practice</button>
            </div>

            {
         submitMsg==="success" ?
        <ConfirmPopUp
            show={show}
            onHide= { ()=>{
              setShow(false)     
              setSubmitMsg('');
              props.handle();
            } } />
            : null
      }

{errorMsg!=='' ?
    <SubmitErrorPopup
        show={errorSubmit}
        onHide={() =>  {setErrorSubmit(false);
                       setErrorMsg('');}}
       
      />: ''
    }


        </div>
    )
}

export default PractiseUpdate
